import { Box } from "@mui/material";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Hero/Hero";
import ImageBanner from "../../components/ImageBanner/ImageBanner";
import Links from "../../components/Links/Links";
import MatchDay from "../../components/MatchDay/MatchDay";
import Popup from "../../components/Popup/Popup";
import { useSettings } from "../../hooks/useSettings";
import * as styles from "./homeStyles";

const Home: React.FC = () => {
    const { data: settings } = useSettings();

    return (
        <Box sx={styles.homeContainer}>
            <Header header={settings?.header} />
            <Hero hero={settings?.hero} />
            {settings?.banner.showTop && <ImageBanner banner={settings.banner} />}
            {settings && <MatchDay settings={settings.matchDay} />}

            <Links />

            {settings?.banner.showBottom && (
                <ImageBanner banner={settings.banner} />
            )}

            <Footer />

            {settings && <Popup popup={settings.popup} />}
        </Box>
    );
};

export default Home;
